module.exports = __webpack_public_path__ + "img/flat_minimalist.e45916a6.jpg";